import React, { Fragment, useEffect, useState } from "react";

import MyCard8 from "../../../tools/MyCard8";
import { SolidButton } from "../../../global/SolidButton";
import MyCard4 from "../../../tools/MyCard4";
import MyCard5 from "../../../tools/MyCard5";
import MyCard6 from "../../../tools/MyCard6";
import MyCard7 from "../../../tools/MyCard7";
import MyCard9 from "../../../tools/MyCard9";
import { CalendarDays, Info, Plus, Trash2 } from "lucide-react";
import {
  addRule,
  deleteRule,
  getRules,
  updateRule,
  updateRuleSettings,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import { MyModal } from "../../../global/MyModal";
import { BorderButton } from "../../../global/BorderButton";
import toast from "react-hot-toast";
import { PencilSimpleLine } from "phosphor-react";

export default function Rule() {
  const [referBonus, setReferBonus] = useState(1);
  const [referEvent, setReferEvent] = useState("signup");

  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [isDisabled, setDisabled] = useState(false);
  const [inviteCount, setInviteCount] = useState(0);
  const [cutting, setCutting] = useState(0);
  const [milestone, setMilestone] = useState(0);
  const [currentRuleId, setCurrentRuleId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isEnableSettings, setEnableSettings] = useState(false);

  let referralEvents = "";
  let referralBonus = 0;
  const fetchRules = async () => {
    try {
      const res = await getRules();
      if (res.status === 200) {
        const data = res?.data;
        setRules(data.rules ?? []);
        const settings = data?.settings;
        const referral_Bonus =
          settings.find((item) => item.name === "REFERRAL_BONUS")?.value || 0;
        const referral_Event = settings.find(
          (item) => item.name === "REFERRAL_EVENT",
        )?.value;
        const milestone_target =
          settings.find((item) => item.name === "MILESTONE_TARGET")?.value || 0;

        // console.log(
        //   "🚀 ~ file: Rule.jsx:82 ~ fetchRules ~ settings:",
        //   settings,
        // );

        setMilestone(milestone_target);
        setReferBonus(Number(referral_Bonus));
        setReferEvent(referral_Event);
        referralEvents = referral_Event;
        referralBonus = referral_Bonus;

        setEnableSettings(
          referralBonus !== !isNaN(Number(referBonus)) &&
            referralEvents.trim() !== referEvent.trim() &&
            referEvent.trim() !== "",
        );
      }
    } catch (err) {
      console.error("failed to fetch rules data :", err);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errs = {};
    //event type validation
    if (!inviteCount || isNaN(Number(inviteCount))) {
      errs.inviteCount = "Invite Count is required";
    }
    //coin amount validation
    if (!cutting || cutting <= 0 || isNaN(Number(cutting))) {
      errs.cutting = "Cutting is required and must be a positive number";
    }
    //milestone
    if (referEvent === "first_earning" && milestone < 1) {
      errs.milestone = "invalid milestone";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  useEffect(() => {
    fetchRules();
  }, []);

  const handleSubmit = () => {
    if (!validateForm()) return;
    setDisabled(true);
    const payload = {
      invites: Number(inviteCount),
      cutting: Number(cutting),
      status: true,
      MILESTONE_TARGET: milestone,
    };
    const addNewBonus = async () => {
      try {
        setDisabled(true);
        const dataRes = isEditMode
          ? await updateRule(currentRuleId, payload)
          : await addRule(payload);

        if (dataRes.status === 200 || dataRes.status === 201) {
          // refresh list
          const res = await getRules();
          toast.success(
            isEditMode
              ? "Rule updated successfully"
              : "Rule added successfully",
          );

          setRules(res.data?.rules || []);

          // close modal and reset
          setIsModalOpen(false);

          setInviteCount(0);
          setCutting(0);

          setErrors({});
          setDisabled(false);
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to add bonus", err);
        // show error toast
      }
    };
    addNewBonus();
  };

  // ------------------------------
  // DELETE RULE
  // ------------------------------
  const handleDelete = async () => {
    try {
      const res = await deleteRule(deleteId);
      if (res.status === 200) {
        toast.success("Rule deleted successfully");
        // refresh list
        fetchRules();
      }
    } catch (err) {
      console.error("Failed to delete configuration", err);
      toast.error(err.response?.data?.error || "Failed to delete config");
    }
    setDeleteId(null);
  };

  // ------------------------------
  // OPEN EDIT MODAL
  // ------------------------------
  const openEditModal = (rule) => {
    setIsEditMode(true);
    setIsModalOpen(true);
    setCurrentRuleId(rule.id);
    handleUpdate(rule);
  };

  // Update
  const handleUpdate = (data) => {
    // fill form
    setInviteCount(data.invites);
    setCutting(data.cutting);
    setErrors({});
  };
  const saveReferEvent = async () => {
    try {
      const payload = {
        referral_event: referEvent,
        referral_bonus: referBonus + "",
        MILESTONE_TARGET: milestone,
      };
      //
      const res = await updateRuleSettings(payload);
      if (res.status === 200) {
        toast.success("Referral event updated successfully");
      }
    } catch (err) {
      console.error("Failed to update referral event", err);
      toast.error(
        err.response?.data?.error || "Failed to update referral event",
      );
    }
  };

  useEffect(() => {
    // Enable settings only if referBonus is a positive number and referEvent is not empty
    if (
      referralBonus !== !isNaN(Number(referBonus)) &&
      referralEvents.trim() !== referEvent.trim() &&
      referEvent.trim() !== ""
    ) {
      setEnableSettings(true);
    } else {
      setEnableSettings(false);
    }
  }, [referBonus, referEvent]);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-2 px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* first section */}
          <div className="md:col-span-2  flex flex-col">
            <SolidButton
              onClick={() => {
                setIsModalOpen(true);
              }}
              className="ml-auto "
            >
              <Plus size={18} />
              <span>Add Rule</span>
            </SolidButton>
            {/* table */}
            <div
              className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
                mt-3
                
               overflow-x-auto
               
                      
              
              "
            >
              <table className="min-w-full border-collapse ">
                <thead>
                  <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                    <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                      ID
                    </th>
                    <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                      Invites
                    </th>
                    <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                      Cutting
                    </th>
                    <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                      Created At
                    </th>

                    <th className="text-end text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pe-4">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rules.map((rule, index) => (
                    <tr
                      key={index}
                      className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40"
                    >
                      <td className="text-xs text-start text-slate-500 dark:text-slate-400  py-4 ps-4">{`# ${rule.id}`}</td>
                      <td className="text-center">
                        <span className="text-xs font-mono text-slate-900 dark:text-slate-200">
                          {rule.invites}
                        </span>
                      </td>
                      <td className="text-center pr-3   uppercase text-xs font-medium text-slate-900 dark:text-slate-200 py-4 ">
                        {rule.cutting}
                      </td>

                      <td>
                        <div className="flex items-center justify-center space-x-1">
                          <CalendarDays className="w-4 h-4 text-slate-500 dark:text-slate-300" />
                          <span className="text-xs text-slate-500 dark:text-slate-300 font-sans">
                            {formatDateTime(rule.created_at)}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="flex items-center justify-end space-x-4 me-4">
                          <PencilSimpleLine
                            className="w-6 h-6 text-slate-800 dark:text-slate-200 border border-slate-200 rounded-sm p-1 cursor-pointer"
                            weight="light"
                            onClick={() => openEditModal(rule)}
                          />
                          <Trash2
                            className="w-6 h-6 text-red-400 border border-slate-200 rounded-sm p-1 cursor-pointer"
                            onClick={() => setDeleteId(rule.id)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* second section */}
          <div className="md:col-span-1  ">
            <MyCard8 className="flex flex-col p-4">
              <h1 className="text-xs font-medium dark:text-white text-slate-800 ">
                Referral Settings
              </h1>
              {/* referrer code */}

              <div className="mt-6">
                <label className="block text-xs font-normal dark:text-white text-slate-500 mb-2">
                  Referrer Bonus*
                </label>

                {/* Input */}
                <input
                  type="number"
                  placeholder="enter refer bonus"
                  value={referBonus}
                  onChange={(e) => setReferBonus(e.target.value)}
                  className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
                />
                <p className="text-[10px] text-slate-400 dark:text-slate-200 font-thin mt-1 font-sans">
                  Bonus cannot per referral
                </p>
              </div>
              <div className="mt-6">
                <label className="block text-xs font-normal dark:text-white text-slate-500 mb-2">
                  Referrer Event
                </label>

                <select
                  name="sortBy"
                  value={referEvent}
                  onChange={(e) => {
                    setReferEvent(e.target.value);
                  }}
                  placeholder="Enter Gateway Name"
                  id=""
                  className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md 
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
                >
                  <option value="signup">Sign Up</option>
                  <option value="first_earning">First Earning</option>
                  <option value="first_withdrawal">First Withdrawal</option>
                </select>
                <p className="text-[10px] text-slate-400 dark:text-slate-200 font-thin mt-1 font-sans">
                  Trigger event for referral bonus
                </p>
              </div>
              {/* Milestone */}
              {referEvent === "first_earning" && (
                <div className="mt-6">
                  <label className="block text-xs font-normal dark:text-white text-slate-500 mb-2">
                    Milestone*
                  </label>

                  {/* Input */}
                  <input
                    type="number"
                    placeholder="enter milestone"
                    value={milestone}
                    onChange={(e) => setMilestone(e.target.value)}
                    className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
                  />
                  <p className="text-[10px] text-slate-400 dark:text-slate-200 font-thin mt-1 font-sans">
                    Set max coins when it is achieved, then increase the refer
                    count.
                  </p>
                </div>
              )}

              <div>
                <SolidButton
                  className={`w-full mt-10 py-2 ${isEnableSettings ? "bg-blue-600" : "bg-slate-400/50 text-slate-50 cursor-not-allowed"}`}
                  onClick={() => saveReferEvent()}
                >
                  <span>Save Changes</span>
                </SolidButton>
              </div>
            </MyCard8>
            {/* Second section */}
            <MyCard9 className=" p-4 mt-4 w-full">
              <div className="flex  flex-row items-start justify-start gap-4 w-full">
                <div>
                  <Info
                    className="text-blue-600  bg-blue-800/25 p-2 rounded-full "
                    size={30}
                  />
                </div>
                <div className="flex flex-col">
                  <h1 className="text-xs text-blue-700 font-semibold dark:text-blue-500">
                    Global Cutting
                  </h1>
                  <p className="text-[10px] text-blue-600 dark:text-blue-400 mt-2 overflow-auto font-normal ">
                    When a user's invite count crosses the threshold defined in
                    the table (e.g., 100 invites), the cutting value is
                    automatically applied.
                  </p>
                  <div className=" w-full bg-blue-500/10 p-2 mt-2 rounded-sm border-[0.2px] border-blue-900">
                    <h1 className="text-[10px] font-normal text-blue-700  dark:text-blue-500">
                      Example:
                    </h1>
                    <p className="text-[10px] text-blue-600 dark:text-blue-400  overflow-auto font-normal ">
                      If cutting is set to 2, the user's visible invite count
                      will be increased after skip 2 when they reach the invite
                      threshold.
                    </p>
                  </div>
                  <p className="text-[9px] text-blue-600 dark:text-blue-500   font-normal italic mt-2  ">
                    This ensures fair reward distribution based on referral
                    milestones.
                  </p>
                </div>
              </div>
            </MyCard9>
          </div>
        </div>
      </div>
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Rule" : "Add New Rule"}
        onClose={() => setIsModalOpen(false)}
        width="500px"
      >
        <div className="mt-4">
          <label className="block text-xs font-medium text-slate-500 mb-1">
            Invite Count*
          </label>
          <input
            type="number"
            placeholder="e.g.,100,500,1000"
            value={inviteCount}
            onChange={(e) => {
              setInviteCount(e.target.value);
              if (errors.inviteCount)
                setErrors((prev) => ({ ...prev, inviteCount: undefined }));
            }}
            aria-invalid={!!errors.inviteCount}
            className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
              errors.inviteCount
                ? "border-red-400"
                : "border-slate-200 dark:border-slate-700"
            }`}
          />
          {errors.inviteCount && (
            <div className="text-xs text-red-500 mt-1">
              {errors.inviteCount}
            </div>
          )}
          <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
            Number of invites required to trigger this rule
          </p>
        </div>

        <div className="mt-4">
          <label className="block text-xs font-medium text-slate-500 mb-1">
            Cutting*
          </label>
          <input
            type="number"
            placeholder="e.g.,2,3,4"
            value={cutting}
            onChange={(e) => {
              setCutting(e.target.value);
              if (errors.cutting)
                setErrors((prev) => ({ ...prev, cutting: undefined }));
            }}
            aria-invalid={!!errors.cutting}
            className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
              errors.cutting
                ? "border-red-400"
                : "border-slate-200 dark:border-slate-700"
            }`}
          />
          {errors.cutting && (
            <div className="text-xs text-red-500 mt-1">{errors.cutting}</div>
          )}
          <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
            Points or percentage to cut when rule is triggered
          </p>
        </div>
        <div className="flex space-x-4 justify-end mt-10">
          <BorderButton onClick={() => setIsModalOpen(false)}>
            <span className="text-sm text-slate-400">Cancel</span>
          </BorderButton>
          <SolidButton
            disabled={isDisabled}
            className="px-4 py-2 text-sm space-x-2"
            onClick={() => handleSubmit()}
          >
            {isEditMode ? "Update Rule" : "Create Rule"}
          </SolidButton>
        </div>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Rule?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this rule?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
function formatDateTime(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  // ✅ prevent RangeError
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}
